import { supabase } from '../config/supabase';
import { TABLES } from '../data/tables';
import { ListingPolicy, ListingType, ListingStatus } from '../data/types/domain';

export const listingPolicyService = {
  async getListingPolicies(): Promise<ListingPolicy[]> {
    const { data, error } = await supabase
      .from(TABLES.LISTING_POLICY)
      .select('*');
    
    if (error) throw error;
    return data || [];
  },

  async getListingPolicyById(id: number): Promise<ListingPolicy | null> {
    const { data, error } = await supabase
      .from(TABLES.LISTING_POLICY)
      .select('*')
      .eq('id', id)
      .single();
    
    if (error) throw error;
    return data || null;
  },

  async getListingPoliciesByBusiness(businessId: number): Promise<ListingPolicy[]> {
    const { data, error } = await supabase
      .from(TABLES.LISTING_POLICY)
      .select('*')
      .eq('business_id', businessId);
    
    if (error) throw error;
    return data || [];
  },

  async createListingPolicy(policy: Omit<ListingPolicy, 'id' | 'created_at' | 'updated_at'>): Promise<ListingPolicy> {
    const { data, error } = await supabase
      .from(TABLES.LISTING_POLICY)
      .insert([{
        ...policy,
        created_at: new Date().toISOString(),
        updated_at: new Date().toISOString(),
      }])
      .select()
      .single();
    
    if (error) throw error;
    return data;
  },

  async updateListingPolicy(
    id: number,
    updates: Partial<Omit<ListingPolicy, 'id' | 'created_at' | 'updated_at'>>
  ): Promise<ListingPolicy> {
    const { data, error } = await supabase
      .from(TABLES.LISTING_POLICY)
      .update({
        ...updates,
        updated_at: new Date().toISOString(),
      })
      .eq('id', id)
      .select()
      .single();
    
    if (error) throw error;
    return data;
  },

  async deleteListingPolicy(id: number): Promise<void> {
    const { error } = await supabase
      .from(TABLES.LISTING_POLICY)
      .delete()
      .eq('id', id);
    
    if (error) throw error;
  },

  async activateListingPolicy(id: number): Promise<ListingPolicy> {
    return this.updateListingPolicy(id, { listing_status: ListingStatus.ACTIVE });
  },

  async deactivateListingPolicy(id: number): Promise<ListingPolicy> {
    return this.updateListingPolicy(id, { listing_status: ListingStatus.INACTIVE });
  },

  async changeListingType(id: number, listingType: ListingType): Promise<ListingPolicy> {
    return this.updateListingPolicy(id, { listing_type: listingType });
  },
}; 